import script from "./ui-accordion.vue?vue&type=script&lang=js"
export * from "./ui-accordion.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__